import React, { FC, useState } from 'react'
import Modal from 'views/components/UI/Modal'
import {
  BottomButtonsContainer,
  ButtonDisabled,
  ModalHeader,
  ModalHelperText,
  ModalNewMapContainer,
  ModalNewMapText,
  StandardButton,
} from './styled'
import CloseIcon from 'assets/icons/CloseIcon'
import { TextField } from '@mui/material'
import BackButton from 'views/components/UI/BackButton'

interface NewMapModalProps {
  show: boolean
  setShow: (show: boolean) => void
  onSave: (mapName: string) => void
}

export const NewMapModal: FC<NewMapModalProps> = ({ show, setShow, onSave }) => {
  const [newMapName, setNewMapName] = useState('')
  const normalizedMapName = newMapName.trim()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value

    setNewMapName(value)
  }

  const handleSave = () => {
    if (!normalizedMapName) {
      return
    }

    onSave(normalizedMapName)
    setShow(false)
  }

  const handleClose = () => {
    setShow(false)
    setNewMapName('')
  }
  return (
    <Modal styleContent={{ width: '560px', minHeight: '280px' }} show={show} setShow={setShow} hideCloseButton>
      <ModalNewMapContainer>
        <BottomButtonsContainer>
          <ModalHeader>
            <ModalNewMapText>Crear nuevo mapa</ModalNewMapText>
            <ModalHelperText>
              Asigna un nombre claro para identificar fácilmente este ejercicio dentro del historial del equipo.
            </ModalHelperText>
          </ModalHeader>
          <CloseIcon onClick={handleClose} color="#000" />
        </BottomButtonsContainer>
        <TextField
          type="text"
          value={newMapName}
          onChange={handleChange}
          label="Nombre de mapa"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && normalizedMapName) {
              handleSave()
            }
          }}
          helperText={`${normalizedMapName.length}/60 caracteres`}
          inputProps={{ maxLength: 60 }}
          sx={{
            borderRadius: '12px',
            boxShadow: '0 10px 28px rgba(22, 50, 71, 0.08)',
            width: '100%',
            '& .MuiOutlinedInput-root': {
              borderRadius: '12px',
              backgroundColor: '#fff',
            },
          }}
        />
        {normalizedMapName.length ? (
          <BottomButtonsContainer>
            <BackButton
              style={{ width: 'auto', padding: '24px 0px' }}
              text="Cancelar"
              type="button"
              onClick={handleClose}
            />
            <StandardButton style={{ minWidth: '120px', alignSelf: 'flex-end' }} onClick={handleSave}>
              Guardar
            </StandardButton>
          </BottomButtonsContainer>
        ) : (
          <BottomButtonsContainer>
            <BackButton
              style={{ width: 'auto', padding: '24px 0px' }}
              text="Cancelar"
              type="button"
              onClick={() => setShow(false)}
            />
            <ButtonDisabled style={{ minWidth: '120px', alignSelf: 'flex-end', justifyContent: 'center' }}>
              Guardar
            </ButtonDisabled>
          </BottomButtonsContainer>
        )}
      </ModalNewMapContainer>
    </Modal>
  )
}

export default NewMapModal
